import {
  driver,
  wsDriver,
  masonrySetTitleBaseActionHandler,
} from '@leagueplatform/masonry';
import { RewardProgramsCardNodeRenderer } from '@leagueplatform/health-journey';
import { MASONRY, MASONRY_V2 } from 'common/constants';
import { RichTextSection } from 'components/masonry-rich-text/masonry-rich-text.component';
import { PwpHeader } from 'components/pwp/pwp-header.component';
import { PwpPrintButton } from 'components/pwp/pwp-pdf-print-button.component';
import { PWPDisclaimerWidget } from 'pages/pwp/pwp-disclaimer-widget.component';
import { EasyPlanWidget } from 'components/easy-plan/easy-plan-widget-component';
import { HsaPendingBannerWidget } from 'components/hsa-pending-banner/hsa-pending-banner-widget.component';
import { RegionBannerHomeRenderer } from 'components/region-selection/region-selection-banner.renderer';
import { GenericStatusBanner } from 'components/status-banner-masonry-widget/generic-status-banner.component';
import { RewardProgramsCarousel } from 'components/carousel/RewardProgramsCarousel';
import { SectionHeaderRenderer } from 'components/masonry-section-header/section-header-renderer.component';
import { SectionHeader } from 'components/masonry-section-header/section-header-widget.component';
import { StatusBannerWithModal } from 'components/status-banner-with-modal/status-banner-with-modal.component';
import { masonryRedirectActionHandler } from 'utils/masonry-redirect-action-handler';
import { masonryGoBackActionHandler } from 'utils/masonry-go-back-action-handler';
import { MasonrySidebarButtonRenderer } from 'components/masonry-sidebar-button-renderer/masonry-sidebar-button-renderer';

export const initMasonryRegistry = () => {
  // Registering overviewText node type to Masonry WS Driver
  wsDriver.nodeRendererRegistry.registerRenderer(
    MASONRY.NODE_TYPE_OVERVIEW_TEXT,
    MASONRY.NAMESPACE_HIGHMARK,
    RichTextSection,
  );
  wsDriver.nodeRendererRegistry.registerRenderer(
    MASONRY.CUSTOM_WIDGET_TYPE_PWP_HEADER,
    MASONRY.NAMESPACE_HIGHMARK,
    PwpHeader,
  );
  wsDriver.nodeRendererRegistry.registerRenderer(
    MASONRY.NODE_TYPE_BUTTON_SECONDARY,
    MASONRY.NAMESPACE_HIGHMARK,
    PwpPrintButton,
  );

  // Registering disclaimer banner node type to Masonry WS Driver
  wsDriver.nodeRendererRegistry.registerRenderer(
    MASONRY.CUSTOM_WIDGET_TYPE_PWP_DISCLAIMER,
    MASONRY.NAMESPACE_HIGHMARK,
    PWPDisclaimerWidget,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REGION_BANNER,
    MASONRY_V2.NAMESPACE_DEFAULT,
    RegionBannerHomeRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_GENERIC_STATUS_BANNER,
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    GenericStatusBanner,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_PENDING_HSA,
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    HsaPendingBannerWidget,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_EASY_PLAN,
    MASONRY_V2.NAMESPACE_EASY_PLAN,
    EasyPlanWidget,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REWARD_PROGRAMS_CARD,
    MASONRY_V2.NAMESPACE_DEFAULT,
    RewardProgramsCardNodeRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REWARD_PROGRAMS_CAROUSEL,
    MASONRY_V2.NAMESPACE_REWARD_PROGRAMS_CAROUSEL,
    RewardProgramsCarousel,
  );

  // Override the section header renderer and widget to enable heading ids
  driver.nodeRendererRegistry.overrideRenderer(
    'sectionHeader',
    MASONRY_V2.NAMESPACE_DEFAULT,
    SectionHeaderRenderer,
  );

  driver.nodeRendererRegistry.overrideRenderer(
    'sectionHeader',
    MASONRY_V2.NAMESPACE_BENEFITS,
    SectionHeaderRenderer,
  );

  wsDriver.nodeRendererRegistry.overrideRenderer(
    'section_header',
    MASONRY.DEFAULT_NAMESPACE,
    SectionHeader,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_SIDEBAR_BUTTON,
    MASONRY_V2.NAMESPACE_DEFAULT,
    MasonrySidebarButtonRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_V2.CUSTOM_WIDGET_TYPE_STATUS_BANNER_WITH_MODAL,
    MASONRY_V2.NAMESPACE_DEFAULT,
    StatusBannerWithModal,
  );

  driver.actionController.registerUniversalHandler(
    'setTitle',
    masonrySetTitleBaseActionHandler,
  );

  driver.actionController.registerHandler(
    'deeplink',
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    masonryRedirectActionHandler,
  );

  driver.actionController.overrideHandler(
    'deeplink',
    MASONRY_V2.NAMESPACE_CUSTOM_ACTION,
    masonryGoBackActionHandler,
  );
};
